/**
 * Launching iconic Builder in Clipspec mode
 * Query Parameters:
 *  - Required: mode=clipspec enables Clipspec mode
 *  - Required: {@link ClipspecWorkflowQueryParam}={@link ClipspecWorkflow} TODO: specifies the Clipspec user flow
 *  - Optional clearData=list clears the product list upon opening
 *
 *  E.g. https://www.clipsal.com/clipsal-switch-socket-builder/?mode=clipspec&flow=consultation
 *  E.g. https://www.clipsal.com/clipsal-switch-socket-builder/?mode=clipspec&flow=product&clearData
 */

export const ClipspecWorkflowQueryParam = 'workflow' as const
export const ClipspecModeQueryParam = 'mode' as const
export const ClipspecClearDataQueryParam = 'clearData' as const

export const ClipspecClearDataQueryParamList = 'list' as const

export enum ClipspecWorkflow {
    Consultation = 'consultation',
    Product = 'product',
}

/**
 * Possible query parameter keys and types, illustrated as an interface
 */
export interface ClipspecIntegrationQueryParams {
    [ClipspecModeQueryParam]: 'clipspec';
    [ClipspecWorkflowQueryParam]: ClipspecWorkflow;
    clearData?: 'list';
}

/**
 * Namespace for postMessage events
 */
export const IconicBuilderClipspecNamespace = 'IconicBuilder.Clipspec' as const

/**
 * messages will be sent as such:
 * window.postMessage({
 *   action, data
 * }, ...)
 */
export interface BaseClipspecPostMessagePayload<ACTION extends string, DATA> {
    action: `${typeof IconicBuilderClipspecNamespace}.${ACTION}`;
    data: DATA;
}

/**
 * Final output of the Consultation flow.
 */
export interface ClipspecProductPostMessagePayload extends BaseClipspecPostMessagePayload<'Handoff', ClipspecIconicProductData[]> {
    action: 'IconicBuilder.Clipspec.Handoff';
    data: ClipspecIconicProductData[];
}

/**
 * Data output for a single configured product from the list.
 */
export interface ClipspecIconicProductData {
    // Full display name for the configured product,
    //  describing the base product and customisation.
    description: string;

    // Quantity of the configured product.
    quantity: number;

    // List of components required to assemble a single instance of the configured product.
    // Assumes components are available individually (as opposed to in bulk packs).
    components: {
        itemNo: string;
        quantity: number;
    }[];

    // Image data encoded as a PNG data URL
    //  or null if an error occurred generating the image.
    image: string | null;
}